import { type ReduxUser, type CommunityBase } from 'models';

import { canManageCommunity } from './canManageCommunity';

// TODO Assets will be not only in community
export const canManageAssets = ({ viewer, community }: { viewer: ReduxUser; community: CommunityBase }) =>
  canManageCommunity({ viewer, community });
